import React from "react";
import { motion } from "framer-motion";
import { Handshake } from "lucide-react";
import { fileUrl } from "../lib/api";

export default function PartnersSection({ partners, content }) {
  const sorted = [...(partners || [])].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  return (
    <section id="partners" data-testid="partners-section" className="py-16 md:py-20 bg-[#120908] border-t border-[#F0E8DB]/10">
      <div className="max-w-6xl mx-auto px-4 sm:px-8">
        <div className="text-center mb-10">
          <div className="text-[#F0E8DB] text-xs tracking-[0.4em] font-serif-en mb-3">PARTNERS</div>
          <h2 className="section-title text-3xl sm:text-4xl">{content.titles.partners}</h2>
          {content.partners_intro && <p className="text-[#A89A88] mt-3 text-sm">{content.partners_intro}</p>}
        </div>
        {sorted.length === 0 ? (
          <div data-testid="partners-empty" className="theater-card rounded-2xl p-8 text-center max-w-xl mx-auto">
            <Handshake size={28} className="text-[#F0E8DB]/70 mx-auto mb-3" />
            <p className="text-[#C5B8A8] text-sm">{content.partners_empty}</p>
          </div>
        ) : (
          <div className="flex flex-wrap justify-center gap-5">
            {sorted.map((p, i) => {
              const inner = (
                <>
                  <div className="w-20 h-20 rounded-xl bg-[#241615] border border-[#F0E8DB]/20 flex items-center justify-center overflow-hidden mb-3">
                    {p.logo_url ? <img src={fileUrl(p.logo_url)} alt={p.name} className="w-full h-full object-contain p-2" loading="lazy" />
                      : <Handshake size={26} className="text-[#F0E8DB]/70" />}
                  </div>
                  <div className="text-[#F0E8DB] text-sm font-semibold">{p.name}</div>
                </>
              );
              const cls = "theater-card rounded-2xl p-5 w-40 flex flex-col items-center text-center hover:border-[#F0E8DB]/60 transition-colors";
              return (
                <motion.div key={p.id} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.06 }}>
                  {p.url ? <a data-testid={`partner-${p.id}`} href={p.url} target="_blank" rel="noreferrer" className={cls}>{inner}</a>
                    : <div data-testid={`partner-${p.id}`} className={cls}>{inner}</div>}
                </motion.div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}
